/* eslint-disable */
export const updateDrawerOpen = ({ commit, dispatch }, data) => {
    commit('UPDATE_DRAWER_OPEN', data)
}
export const updateProductsLoading = ({ commit, dispatch }, data) => {
    commit('UPDATE_PRODUCTS_LOADING', data)
}
export const updateTotalsLoading = ({ commit, dispatch }, data) => {
    commit('UPDATE_TOTALS_LOADING', data)
}